import type { FigmaIconProps } from './types';

export const IconFigmaChevronRight = ({ size = 14, color = 'currentColor' }: FigmaIconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.79658 3.04658C5.04717 2.796 5.4529 2.796 5.70349 3.04658L9.20349 6.54658C9.45404 6.79717 9.45406 7.20291 9.20349 7.45349L5.70349 10.9535C5.45291 11.2041 5.04717 11.204 4.79658 10.9535C4.546 10.7029 4.546 10.2972 4.79658 10.0466L7.84313 7.00004L4.79658 3.95349C4.546 3.7029 4.546 3.29717 4.79658 3.04658Z"
      fill={color}
    />
  </svg>
);
